import { render, staticRenderFns } from "./SubscriptionItem.vue?vue&type=template&id=58754744&scoped=true&"
import script from "./SubscriptionItem.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionItem.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionItem.vue?vue&type=style&index=0&id=58754744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58754744",
  null
  
)

export default component.exports